import { Button, Col, DatePicker, Form, Row, Select } from "antd";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { ISuppliersByNameResponse, ISuppliersByNameResult } from "../../../interfaces/supplier";
import { SupplierServices } from "../../../services/supplier";
import { DATE_FORMAT } from "../../../constants/common";

const filterSelectOption = (input: string, option?: { label: string }) =>
  (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

interface FilterDashboardProps {
  initialValues: any;
  onChangeFilter: (value: any) => void;
}

const FilterDashboard: React.FC<FilterDashboardProps> = ({ onChangeFilter, initialValues }) => {
  const [form] = Form.useForm();
  const [suppliers, setSuppliers] = useState<ISuppliersByNameResult[]>([]);

  const fetchSuppliers = async () => {
    try {
      const res: ISuppliersByNameResponse = await SupplierServices.getSuppliersByName({
        params: { page: 1, pageSize: 5000, isExcludeReport: false },
      });
      setSuppliers(res?.data?.results || []);
    } catch (error) {}
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  const handleFilter = (values: any) => {
    onChangeFilter(values)
  };

  return (
    <Form form={form} initialValues={initialValues} layout="horizontal" onFinish={handleFilter} className="box-filter">
      <Row justify={"space-between"} gutter={24} align={"bottom"}>
        <Col span={8}>
          <div className="label">Filter by Supplier:</div>
          <Form.Item label={null} name="supplierIds">
            <Select
              showSearch
              allowClear
              filterOption={filterSelectOption}
              options={suppliers.map((item: ISuppliersByNameResult) => ({
                value: item.key,
                label: `${item.code} - ${item.label}`,
              }))}
              placeholder="All"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <div className="label">Filter by date:</div>
          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <Row gutter={24}>
                <Col span={12}>
                  <Form.Item label="From" name="startDate">
                    <DatePicker
                      format={DATE_FORMAT}
                      maxDate={dayjs(getFieldValue("endDate"), DATE_FORMAT)}
                      style={{ width: "100%" }}
                      placeholder="From"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="To" name="endDate">
                    <DatePicker
                      format={DATE_FORMAT}
                      minDate={dayjs(getFieldValue("startDate"), DATE_FORMAT)}
                      style={{ width: "100%" }}
                      placeholder="To"
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}
          </Form.Item>
        </Col>
        <Col span={4} style={{ textAlign: "right" }}>
          <Button type="primary" htmlType="submit" style={{ height: "32px", lineHeight: 1, minWidth: 100 }}>
            Apply
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default FilterDashboard;
